import React, { Suspense } from 'react';

import {
  InteractionAccordionPanelProps,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';

import { PurchasePixel } from '$/components/ui/Input/Editors/EmbedCodeBox';
import { PurchaseTrackingPopup } from '$/components/Interactions/Offer/PurchaseTrackingPopup';

import { useMe } from '$/hooks/useMe';
import { createWebinarSetPurchasePixelUrl } from '$/utils/pixel';
import Form from '$/components/ui/Form';

const ThinkificPromoCardSettings = React.lazy(() => import('./ThinkificPromoCardSettings'));

export const useThinkificPromoInteractionSettings: (
  props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[] = ({ interaction, state, setDisableEdit }) => {
  const me = useMe();

  // @See: https://ewebinar-app.thinkific.com/manage/settings#tab-code-analytics
  const pixelUrl = createWebinarSetPurchasePixelUrl(me.team, state.set.id)
    .replace('{{email}}', '{{billing_email}}')
    .replace('{{amount}}', '{{total_price}}')
    .replace('{{order_id}}', '{{order_number}}')
    .replace('{{product_id}}', '{{product_id}}')
    .replace('{{product_name}}', '{{product_name}}')
    .replace('{{currency}}', 'USD'); // Thinkific uses US Dollars

  return [
    {
      key: 'ThinkificProduct',
      active: true,
      title: {
        content: <Form.AccordionTitle title={'Thinkific product'} />,
      },
      content: {
        content: (
          <Suspense>
            <ThinkificPromoCardSettings
              interaction={interaction}
              state={state}
              setDisableEdit={setDisableEdit}
            />
          </Suspense>
        ),
      },
    },
    {
      key: 'SalesTracking',
      title: {
        content: (
          <Form.AccordionTitle
            title={
              <div className='inline-flex'>
                Conversion tracking
                <PurchaseTrackingPopup />
              </div>
            }
          />
        ),
      },
      content: {
        content: (
          <div className='flex justify-center items-stretch'>
            <PurchasePixel purchasePixelUrl={pixelUrl} />
          </div>
        ),
      },
    },
  ];
};
